import { requestApiBlob, requestApiJson } from '../shared/api/client'
import { withCookieFirstRequest } from '../shared/api/cookieAuthRequest'

export const toCustomerPrivacyErrorMessage = (status: number, payload: unknown) => {
  if (payload && typeof payload === 'object') {
    const message = (payload as { message?: unknown }).message
    if (typeof message === 'string' && message.trim()) {
      return message.trim()
    }
  }

  if (status === 400) return 'Richiesta privacy non valida'
  if (status === 401) return 'Sessione cliente non valida'
  if (status === 403) return 'Operazione privacy non autorizzata'
  if (status === 404) return 'Risorsa privacy non trovata'
  if (status === 409) return 'Operazione privacy non disponibile in questo stato'
  if (status === 410) return 'Export privacy scaduto'
  if (status === 429) return 'Troppi tentativi, riprova tra poco'
  if (status === 503) return 'Servizio privacy non raggiungibile'
  if (status === 504) return 'Timeout servizio privacy'
  return 'Errore gestione privacy account'
}

export class CustomerPrivacyApiError extends Error {
  status: number

  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

export const requestCustomerPrivacyJson = <T>(
  path: string,
  init: Omit<RequestInit, 'headers'> = {},
  token?: string | null,
) =>
  requestApiJson<T>({
    path,
    init: withCookieFirstRequest({
      init,
      bearerFallbackToken: token,
    }),
    defaultHeaders: {
      'Content-Type': 'application/json',
    },
    toErrorMessage: toCustomerPrivacyErrorMessage,
    createError: (status, message) => new CustomerPrivacyApiError(status, message),
  })

export const requestCustomerPrivacyBlob = ({
  token,
  downloadUrl,
}: {
  token?: string | null
  downloadUrl: string
}) =>
  requestApiBlob({
    url: downloadUrl,
    init: withCookieFirstRequest({
      init: {
        method: 'GET',
      },
      bearerFallbackToken: token,
    }),
    toErrorMessage: toCustomerPrivacyErrorMessage,
    createError: (status, message) => new CustomerPrivacyApiError(status, message),
  })
